import { ProviderBuilder, EGenMode } from '@educraft/base';
import { Vybarveni } from './generators/Vybarveni';
import { Inicialy__1 } from './generators/Inicialy__1';
import { Inicialy__2 } from './generators/Inicialy__2';
import { Inicialy__3 } from './generators/Inicialy__3';
import { Inicialy__4 } from './generators/Inicialy__4';
import { WordBuilder } from './generators/WordBuilder';
import { HledaniPismen } from './generators/HledaniPismen';
import { Pismena } from './generators/Pismena';
import { Vejir__2, Vejir__3 } from './generators/Vejir';
import { UhodniSlovo } from './generators/UhodniSlovo';
import { Kolicky__Pismena } from './generators/Kolicky__Pismena';
import {
  Pisanka__Basic,
  Pisanka__Empty,
  Pisanka__Trace,
  Pisanka__Progressive,
  Pisanka__MultiLine,
  Pisanka__Syllables,
} from './generators/Pisanka';
import { Presmycky } from './generators/Presmycky';
import { KoloLosovani } from './generators/KoloLosovani';
import { Kolicky__Presmycky } from './generators/Kolicky__Presmycky';
import { Osmismerka__3, Osmismerka__8 } from './generators/Osmismerka';

import { AR } from './generators/AR';
import { QR } from './generators/QR';
import {
  Telefon__Base,
  Telefon__Tlacitkovy,
  Telefon__Tablet,
  Telefon__Retro,
  Telefon__Otocivy,
} from './generators/Telefon';
import {
  QR_Hra__Hunt,
  QR_Hra__Path,
  QR_Hra__Trail,
  QR_Hra__Seek,
  QR_Hra__Check,
  QR_Hra__Collect,
  QR_Hra__Pairs,
  QR_Hra__Quiz,
  QR_Hra__Task,
  QR_Hra__Run,
  QR_Hra__Hint,
  QR_Hra__Trail_Hint,
} from './generators/QR_Hra';

export function registerLayoutLabelText(builder: ProviderBuilder) {
  builder.add(EGenMode.LayoutLabelText, Vybarveni, 'LabelText.Vybarveni');
  builder.add(EGenMode.LayoutLabelText, Inicialy__1, 'LabelText.Inicialy__1');
  builder.add(EGenMode.LayoutLabelText, Inicialy__2, 'LabelText.Inicialy__2');
  builder.add(EGenMode.LayoutLabelText, Inicialy__3, 'LabelText.Inicialy__3');
  builder.add(EGenMode.LayoutLabelText, Inicialy__4, 'LabelText.Inicialy__4');
  builder.add(EGenMode.LayoutLabelText, WordBuilder, 'LabelText.WordBuilder');
  builder.add(EGenMode.LayoutLabelText, HledaniPismen, 'LabelText.HledaniPismen');
  builder.add(EGenMode.LayoutLabelText, Pismena, 'LabelText.Pismena');
  builder.add(EGenMode.LayoutLabelText, Vejir__2, 'LabelText.Vejir__2');
  builder.add(EGenMode.LayoutLabelText, Vejir__3, 'LabelText.Vejir__3');
  builder.add(EGenMode.LayoutLabelText, UhodniSlovo, 'LabelText.UhodniSlovo');
  builder.add(EGenMode.LayoutLabelText, Kolicky__Pismena, 'LabelText.Kolicky__Pismena');
  builder.add(EGenMode.LayoutLabelText, Pisanka__Basic, 'LabelText.Pisanka__Basic');
  builder.add(EGenMode.LayoutLabelText, Pisanka__Empty, 'LabelText.Pisanka__Empty');
  builder.add(EGenMode.LayoutLabelText, Pisanka__Trace, 'LabelText.Pisanka__Trace');
  builder.add(EGenMode.LayoutLabelText, Pisanka__Progressive, 'LabelText.Pisanka__Progressive');
  builder.add(EGenMode.LayoutLabelText, Pisanka__MultiLine, 'LabelText.Pisanka__MultiLine');
  builder.add(EGenMode.LayoutLabelText, Pisanka__Syllables, 'LabelText.Pisanka__Syllables');
  builder.add(EGenMode.LayoutLabelText, Presmycky, 'LabelText.Presmycky');
  builder.add(EGenMode.LayoutLabelText, KoloLosovani, 'LabelText.KoloLosovani');
  builder.add(EGenMode.LayoutLabelText, Kolicky__Presmycky, 'LabelText.Kolicky__Presmycky');
  builder.add(EGenMode.LayoutLabelText, Osmismerka__3, 'LabelText.Osmismerka__3');
  builder.add(EGenMode.LayoutLabelText, Osmismerka__8, 'LabelText.Osmismerka__8');

  builder.add(EGenMode.LayoutLabelText, AR, 'LabelText.AR');
  builder.add(EGenMode.LayoutLabelText, QR, 'LabelText.QR');
  builder.add(EGenMode.LayoutLabelText, Telefon__Base, 'LabelText.Telefon__Base');
  builder.add(EGenMode.LayoutLabelText, Telefon__Tlacitkovy, 'LabelText.Telefon__Tlacitkovy');
  builder.add(EGenMode.LayoutLabelText, Telefon__Tablet, 'LabelText.Telefon__Tablet');
  builder.add(EGenMode.LayoutLabelText, Telefon__Retro, 'LabelText.Telefon__Retro');
  builder.add(EGenMode.LayoutLabelText, Telefon__Otocivy, 'LabelText.Telefon__Otocivy');
  builder.add(EGenMode.LayoutLabelText, QR_Hra__Hunt, 'LabelText.QR_Hra__Hunt');
  builder.add(EGenMode.LayoutLabelText, QR_Hra__Path, 'LabelText.QR_Hra__Path');
  builder.add(EGenMode.LayoutLabelText, QR_Hra__Trail, 'LabelText.QR_Hra__Trail');
  builder.add(EGenMode.LayoutLabelText, QR_Hra__Seek, 'LabelText.QR_Hra__Seek');
  builder.add(EGenMode.LayoutLabelText, QR_Hra__Check, 'LabelText.QR_Hra__Check');
  builder.add(EGenMode.LayoutLabelText, QR_Hra__Collect, 'LabelText.QR_Hra__Collect');
  builder.add(EGenMode.LayoutLabelText, QR_Hra__Pairs, 'LabelText.QR_Hra__Pairs');
  builder.add(EGenMode.LayoutLabelText, QR_Hra__Quiz, 'LabelText.QR_Hra__Quiz');
  builder.add(EGenMode.LayoutLabelText, QR_Hra__Task, 'LabelText.QR_Hra__Task');
  builder.add(EGenMode.LayoutLabelText, QR_Hra__Run, 'LabelText.QR_Hra__Run');
  builder.add(EGenMode.LayoutLabelText, QR_Hra__Hint, 'LabelText.QR_Hra__Hint');
  builder.add(EGenMode.LayoutLabelText, QR_Hra__Trail_Hint, 'LabelText.QR_Hra__Trail_Hint');
}
